document.addEventListener('DOMContentLoaded', function () {
    const omnibusText = document.querySelectorAll('[id^="frykland-lowestprice-wrapper"]');
    const locale = Shopify.locale;
    const stringOverridesByLocale = {
        sk: { "Najnižšia cena v posledných 30 dňoch:": "Najnižšia cena za posledných 30 dní:" }
    };

    if (omnibusText.length > 1) {
        console.warn('more than 1 frykland wrapper price');
        return;
    }

    omnibusText.forEach(element => {
        const textChange = stringOverridesByLocale[locale];
        if (!textChange) return;

        const labelNode = Array.from(element.childNodes)
            .find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '');

        if (!labelNode) return;

        const ownText = labelNode.textContent.trim();
        const replacement = textChange[ownText];
        if (!replacement) return;

        labelNode.textContent = replacement + ' ';
        element.style.visibility = 'visible';
    });
});